import React from 'react';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import Navigation from './navigation.js';
import Footerband from './components/footerband';
//import { loadReCaptcha } from 'react-recaptcha-v3';

const App = () => {
    return (
      <Router>
        <Navigation />
        <Footerband />
      </Router>
    );
  }


export default App;
